document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pd-form]').forEach(function (formEl) {
    var mainImage = formEl.querySelector('#pd-main-image');
    var thumbs = formEl.querySelectorAll('[data-pd-thumb]');
    var swatches = formEl.querySelectorAll('[data-pd-swatch]');
    var variantSelect = formEl.querySelector('[data-pd-variant-select]');
    var priceEl = formEl.querySelector('[data-pd-price]');
    var comparePriceEl = formEl.querySelector('[data-pd-compare-price]');
    var qtyInput = formEl.querySelector('[data-pd-qty-input]');
    var qtyMinus = formEl.querySelector('[data-pd-qty-minus]');
    var qtyPlus = formEl.querySelector('[data-pd-qty-plus]');
    var addBagBtn = formEl.querySelector('[data-pd-addbag]');
    var buyNowBtn = formEl.querySelector('[data-pd-buynow]');

    // Gallery thumbnails
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.getAttribute('data-full');
        }
      });
    });

    // Color swatches -> match variant by option1 (assumes Color is the only/primary option)
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-checked', 'true');

        var value = swatch.getAttribute('data-value');
        if (!variantSelect) return;

        var options = Array.prototype.slice.call(variantSelect.options);
        var match = options.find(function (opt) {
          return opt.getAttribute('data-color') === value;
        });

        if (match) {
          variantSelect.value = match.value;
          if (priceEl) priceEl.textContent = match.getAttribute('data-price');
          if (comparePriceEl) {
            var comparePrice = match.getAttribute('data-compare-price');
            var price = match.getAttribute('data-price');
            if (comparePrice && comparePrice !== price && comparePrice !== '$0.00') {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.hidden = false;
            } else {
              comparePriceEl.hidden = true;
            }
          }
          var available = match.getAttribute('data-available') === 'true';
          if (addBagBtn) {
            addBagBtn.disabled = !available;
            var label = addBagBtn.querySelector('[data-pd-addbag-label]');
            if (label) label.textContent = available ? 'Add to Bag' : 'Sold Out';
          }
          if (buyNowBtn) buyNowBtn.style.display = available ? '' : 'none';
        }
      });
    });

    // Quantity stepper
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Buy It Now -> add to cart then redirect straight to checkout
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled) return;
        var variantId = variantSelect ? variantSelect.value : null;
        var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (!variantId) return;

        buyNowBtn.disabled = true;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = 'Redirecting...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = originalText;
          });
      });
    }
  });
  const selectedValue = document.querySelector(".pd-variant-select").value;
  const params = new URLSearchParams(window.location.search);
  const selectedVariant = params.get("variant");

  let option;

  if (selectedVariant) {
      option = document.querySelector(
          `.pd-variant-select option[value="${selectedVariant}"]`
      );
  } else {
      option = document.querySelector(
          `.pd-variant-select option[value="${selectedValue}"]`
      );
  }

  if (option) {
      const color = option.dataset.color;

      const swatch = document.querySelector(
          `.pd-swatch[data-value="${color}"]`
      );

      if (swatch) {
          swatch.click();
      }
  }
});
